import React, { useState } from 'react';
import { SectionShell, NumField, TextAreaField, saveSection } from './shared';

export function SafetyEditor({ data, dept, deptLabel, onSaved, projectId, date, readOnly }) {
  const [toolbox, setToolbox] = useState(data.toolbox_talks ?? 0);
  const [incidents, setIncidents] = useState(data.incidents ?? 0);
  const [ppeViol, setPpeViol] = useState(data.ppe_violations ?? 0);
  const [notes, setNotes] = useState(data.safety_notes || '');
  const [ppePct, setPpePct] = useState(data.ppe_compliance_pct ?? 100);
  const [saving, setSaving] = useState(false);

  const save = () => saveSection(projectId, date, dept, {
    toolbox_talks: parseInt(toolbox, 10) || 0,
    incidents: parseInt(incidents, 10) || 0,
    ppe_violations: parseInt(ppeViol, 10) || 0,
    safety_notes: notes,
    ppe_compliance_pct: Math.max(0, Math.min(100, parseFloat(ppePct) || 0)),
  }, onSaved, deptLabel, setSaving);

  return (
    <SectionShell deptLabel={deptLabel} dept={dept} onSave={save} saving={saving} readOnly={readOnly}>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <NumField label="Toolbox talks today" value={toolbox} onChange={setToolbox} testid="dpr-safety-toolbox" />
        <NumField label="Incidents / near-misses" value={incidents} onChange={setIncidents} testid="dpr-safety-incidents" />
        <NumField label="PPE violations" value={ppeViol} onChange={setPpeViol} testid="dpr-safety-ppe-violations" />
        <NumField label="PPE compliance %" value={ppePct} onChange={setPpePct} min={0} max={100} testid="dpr-safety-ppe-pct" />
      </div>
      <TextAreaField label="Safety notes" value={notes} onChange={setNotes} rows={2} testid="dpr-safety-notes" />
    </SectionShell>
  );
}
